export default "__VITE_ASSET__Dqualb8W__"